module.exports = __webpack_public_path__ + "img/mountain.75577015.jpeg";